/* The existing form remains usable while the compatible backend is prepared. */
(function () {
  'use strict';
  var tag = document.currentScript;
  var view = tag && tag.dataset.rsvFlowView;
  if (!['reserve-continuous-v3','reserve-futo-continuous-v3','reschedule-continuous-v3'].includes(view)) return;
  var url = new URL(location.href);
  if (url.searchParams.has('view')) return;
  if (window.__JIYUCHO_FLOW_BOOTSTRAP_V3__) return;
  window.__JIYUCHO_FLOW_BOOTSTRAP_V3__ = true;
  function start() {
    var change = view === 'reschedule-continuous-v3';
    var submitting = false;
    document.addEventListener('submit', function (event) {
      if (event.target && event.target.id === 'ReservationForm') submitting = true;
    }, true);
    // Same allowlist, key and version consumed by the existing intake restore UI.
    var ids = ['ReservationForm-name','ReservationForm-email','confirm-email','ReservationForm-country',
      'ReservationForm-phone-country-code','ReservationForm-phone-local','ReservationForm-numperson',
      'ReservationForm-menu','ReservationForm-option','ReservationForm-reason','ReservationForm-message',
      'reservationId','lookupEmailById','lookupPhoneById','recoveryName','recoveryPhone','recoveryVisitDate'];
    function handoff() {
      var values = {};
      ids.forEach(function (id) {
        var field = document.getElementById(id);
        if (!field || field.type === 'password') return;
        if (field.value.length > 10000) throw Error('entry too long');
        // Include empty strings: never resurrect a value the customer cleared.
        values[id] = field.value;
      });
      var dates = ['1','2'].map(function (choice) {
        var field = document.getElementById('ReservationForm-schedule' + choice);
        return field && field.value || '';
      });
      var key = 'reservation-intake-draft-v1:' + location.pathname;
      var defaults = ['ReservationForm-country','ReservationForm-phone-country-code','ReservationForm-menu','ReservationForm-option','ReservationForm-reason'];
      var hasEntries = dates.some(Boolean) || Object.keys(values).some(function (id) {
        var field = document.getElementById(id);
        if (!values[id]) return false;
        if (defaults.indexOf(id) < 0) return true;
        var defaultValue = field.tagName === 'SELECT'
          ? ((Array.from(field.options).find(function (option) { return option.defaultSelected; }) || field.options[0] || {}).value || '')
          : field.defaultValue;
        return values[id] !== defaultValue;
      });
      if (!hasEntries) { try { sessionStorage.removeItem(key); } catch (_) {} return; }
      var data = JSON.stringify({version:1, handoff:true, expiresAt:Date.now()+5*60*1000, values:values, dates:dates});
      sessionStorage.setItem(key, data);
      if (sessionStorage.getItem(key) !== data) throw Error('handoff not saved');
    }
    function handoffFailed() {
      var form = document.getElementById('ReservationForm');
      if (!form || document.getElementById('reservation-flow-handoff-failed')) return;
      var notice = document.createElement('p');
      notice.id = 'reservation-flow-handoff-failed'; notice.setAttribute('role','status');
      var english = /^en/i.test(document.documentElement.lang || '') || /^\/en\//.test(location.pathname);
      notice.textContent = english
        ? 'We could not transfer your entries to the updated page. Your entries remain on this page. Please make a note of them before reloading, or try again later.'
        : '新版への入力の引継ぎができませんでした。入力はこのページに保持しています。必要な内容を控えてから再読み込みするか、時間をおいてお試しください。';
      form.parentNode.insertBefore(notice, form);
    }
    var endpoint = 'https://asia-northeast1-store-rsv-system-project.cloudfunctions.net/' + (change ? 'submitRescheduleRequestV2' : 'submitReservationV2');
    fetch(endpoint+'?intake_status=1', {cache:'no-store', signal:AbortSignal.timeout(5000)})
      .then(function(response){if(!response.ok)throw Error('unavailable');return response.json();})
      .then(function(status){
        if (submitting || status.contract !== 'reservation-intake-v1' || status.flow !== 'active' ||
            status.newFlowAvailable !== true || status.accepting !== true || !Number.isFinite(Date.parse(status.expiresAt)) || Date.parse(status.expiresAt) <= Date.now()) return;
        var topic = document.getElementById('requestType');
        if (change && topic && topic.value === 'cancel') return;
        // Capture current values immediately before navigation, including autofill/edits.
        try { handoff(); } catch (_) { handoffFailed(); return; }
        url.searchParams.set('view',view);
        location.replace(url.href);
      }).catch(function(){ /* Existing page and input remain usable. */ });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
